var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2 text-orange-700 bg-red-100 rounded-full"},[_c('BellIcon',{class:_vm.dropdown ? 'w-4 h-4' : 'w-6 h-6'})],1)}
var staticRenderFns = []

export { render, staticRenderFns }